import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';
import { PiwikProUtils } from '../../common/utility/piwikProUtils';
import { InboxService } from '../../services/inbox.service';
import { TabDataService } from '../../services/tab-data.service';
import { UserDataService } from '../../services/user-data.service';
import {HttpClient} from "@angular/common/http";
import {
  copyBlobToClipboard,
} from 'copy-image-clipboard';
import { AttachmentViewerDialogComponent } from '../../common/component/attachment-viewer/attachmentviewer.dialog.component';

@Component({
  selector: 'app-attachment',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.scss'],
})
export class AttachmentComponent implements OnInit, OnChanges {
  @Input() attachments: any = [];
  attachmentList: any = [];
  attachmentCount: number = 0;
  copyAllImage: string = "copy_icon.svg";
  sAttachViewUrl: string;
  @ViewChild('attachViewer') attachViewer: AttachmentViewerDialogComponent;

  constructor(
    private userDataService: UserDataService,
    private inboxService: InboxService,
    private messageService: MessageService,
    private tabDataService: TabDataService,
    private http: HttpClient,
  ) {}

  ngOnInit() {}

  ngOnChanges(): void {
    this.attachmentList = [];
    this.attachmentCount = 0; //C153176-4478 download all visible for all

    if (this.attachments.length > 0) {
      this.attachmentCount = this.attachments.length;
      Array.prototype.push.apply(this.attachmentList, this.attachments);
    }
  }

  /**
   * Method to download attachments attached to conversation
   *
   * @param attachments - Conversation Attachment list
   */
  onDownloadAttachment(attachments: any): void {
    console.log('Only one attachment', attachments.name, attachments);
    this.inboxService.downloadAttachment(
      attachments.id,
      attachments.name,
      attachments.convId,
      attachments.groupId,
      attachments.hasNominatedOwnership
    );
    PiwikProUtils.trackJsonDataForEvent(
      this.userDataService.loggedInUserInfo.pivotProConfigEnabled,
      this.userDataService.loggedInUserInfo.userId,
      'Mailboxes ',
      'Download attachment',
      'Click',
      'Download attachment',
      0
    );
  }
  /**
   * Method to download attachments attached to conversation
   *
   * @param attachments - Conversation Attachment list
   */
  onCopyAttachment(attachments: any): void {
   this.inboxService.onCopyAttachment(attachments);
  }

  /**
   * Method to download all the attachments from the Inquiry
   */
  onDownloadAllAttachment(): void {
    if (this.attachmentList.length > 1) {
      console.log('More than one attachment : ', this.attachmentList.length);
      const inquiryId = this.attachmentList[0].inquiryId;
      const groupId =
        this.attachmentList &&
        this.attachmentList[0] &&
        this.attachmentList[0].groupId
          ? this.attachmentList[0].groupId
          : null;
      this.inboxService.downloadAllAttachments(inquiryId, null, groupId);
    } else {
      this.onDownloadAttachment(this.attachmentList[0]);
    }
    PiwikProUtils.trackJsonDataForEvent(
      this.userDataService.loggedInUserInfo.pivotProConfigEnabled,
      this.userDataService.loggedInUserInfo.userId,
      'Mailboxes ',
      'Download all attachments',
      'Click',
      'Download all attachments',
      0
    );
  }

  getFileIcon(fileName: string): string {
    // Get the file extension
    const extension = fileName.split('.').pop()?.toLowerCase();
    // Return the appropriate icon path based on the file extension
    switch (extension) {
      case 'xls':
      case 'xlsx':
        return 'assets/Inbox/fileTypeXLS.svg';
      case 'png':
        return 'assets/Inbox/fileTypePNG.svg';
      case 'jpg':
      case 'jpeg':
        return 'assets/Inbox/fileTypeJPG.svg';
      case 'zip':
        return 'assets/Inbox/fileTypeZIP.svg';
      case 'ppt':
      case 'pptx':
        return 'assets/Inbox/fileTypePPT.svg';
      case 'doc':
        return 'assets/Inbox/fileTypeDOC.svg';
      case 'docx':
        return 'assets/Inbox/fileTypeDOCX.svg';
      case 'svg':
        return 'assets/Inbox/fileTypeSVG.svg';
      case 'pdf':
        return 'assets/Inbox/fileTypePDF.svg';
      case 'html':
        return 'assets/Inbox/fileTypeHTML.svg';
      case 'csv':
        return 'assets/Inbox/fileTypeCSV.svg';
      default:
        return 'assets/Inbox/fileTypeDOC.svg'; // Default icon for other file types
    }
  }
  onPinPanel(){
    this.tabDataService.setSidePanelPin(true);
    this.userDataService.setSidePanelPinned(true);
  }
  onViewctionRedesigned(attachement) {
    let event = { target: { name: 'view', title: attachement.name } };
    this.onDownloadAction(event, null);
}
onDownloadAction(event, overlaypanel: OverlayPanel): void {
  const selectedAttachment = this.attachmentList.find(option => option.name === event.target.title);

  if (event.target.name == "copy") {

      // C153176-5490 | One last item shoud be available for attachment for attahment.
      // We need to clear the session storage on new attachment request.
      console.log("Only last item should available to paste for attachment");
      sessionStorage.removeItem("copiedattch");
      this.copyAllImage = "copy_icon.svg";

      let bAddNewAttach: boolean = false;// C153176-4708	display toaster message on click
      let attachments = selectedAttachment.fileInfo;

      this.attachmentList.forEach(attachment => {
          if (attachment.name != attachments.name) {
              attachment.imageName = 'copy_icon.svg';
          }
      });

      if (Array.isArray(attachments)) {
          if (attachments.length === 1) {
              console.log('Only one attachment : ', attachments[0].name);
              let curVal = sessionStorage.getItem('copiedattch');
              if (curVal == null) {
                  curVal = '';
                  bAddNewAttach = true;
              } else {
                  if (curVal.indexOf(attachments[0].name) == -1) {
                      bAddNewAttach = true;
                  }
              }
              if (bAddNewAttach == true) {
                  sessionStorage.setItem('copiedattch', curVal + '~' + this.inboxService.viewAttachment(attachments[0].id, attachments[0].name, attachments[0].convId, attachments[0].groupId, attachments[0].hasNominatedOwnership) + ':' + attachments[0].name);
                  const attachmentUrl = this.inboxService.copyAttachment(attachments[0].id, attachments[0].convId, attachments[0].groupId, attachments[0].hasNominatedOwnership);
                  let extension = attachments[0].name.split(".").pop();
                  console.log("Extenstion : " + extension);
                  if (extension == "png" || extension == "jpg" || extension == "jpeg" || extension == "gif" || extension == "bmp") {
                      this.getFileBlob(attachmentUrl);

                      // C153176-4648 - Show 'Copied' message on copy of an attachment.
                      this.messageService.add({severity: 'success', key: 'qmaToast', summary: '', detail: 'Copied'});
                  } else {
                      this.messageService.add({
                          severity: 'error',
                          key: 'qmaToast',
                          summary: '',
                          detail: 'Selected format is not supported for copying'
                      });
                  }
              }
          }
      }
      else {
          let curVal = sessionStorage.getItem('copiedattch');
          if (curVal == null) {
              curVal = '';
              bAddNewAttach = true;// C153176-4648 - Show 'Copied' message on copy of an attachment.
          } else {
              if (curVal.indexOf(attachments.name) == -1) {
                  bAddNewAttach = true;
              }
          }
          if (bAddNewAttach == true) {
              sessionStorage.setItem('copiedattch', curVal + '~' + this.inboxService.viewAttachment(attachments.id, attachments.name, attachments.convId, attachments.groupId, attachments.hasNominatedOwnership) + ':' + attachments.name);

              const attachmentUrl =  this.inboxService.copyAttachment(attachments.id, attachments.convId, attachments.groupId, attachments.hasNominatedOwnership);
              let extension = attachments.name.split(".").pop();
              console.log("Extenstion : " + extension);
              if (extension == "png" || extension == "jpg" || extension == "jpeg" || extension == "gif" || extension == "bmp") {
                  this.getFileBlob(attachmentUrl);

                  // C153176-4648 - Show 'Copied' message on copy of an attachment.
                  this.messageService.add({severity: 'success', key: 'qmaToast', summary: '', detail: 'Copied'});
              } else {
                  this.messageService.add({
                      severity: 'error',
                      key: 'qmaToast',
                      summary: '',
                      detail: 'Selected format is not supported for copying'
                  });
              }
          }
      }
  } else {
      if (overlaypanel) {
          overlaypanel.hide();
      }

      //  this.attachByteArray = this.inboxService.attachBinary;******
      var filename = "";
      if (!Array.isArray(selectedAttachment.fileInfo)) {
          filename = selectedAttachment.name;
      }
      else
          filename = selectedAttachment.name;
      var extension = filename.split('.').pop().toLowerCase();

      var isViewed = false;

      console.log('attach file extension ' + extension);

      if ((event && event.target && event.target.classList && event.target.classList.contains('attach-name-opt') === true)
          || event.target.name === "view") {
          this.setAttachmentUrl(selectedAttachment);
          if (extension !== 'doc' &&
              extension !== 'ppt' &&
              extension !== 'pptx' &&
              extension !== 'zip' &&
              extension !== 'rar' &&
              extension !== 'wpd' &&
              extension !== 'msg' &&
              extension !== '7z') {
              isViewed = this.attachViewer.displayDialog();
          } else {
              alert('The selected file type is not supported for inline preview');
          }
      }

      if (isViewed === true) {   //view attachment
          var attchViewer = this.attachViewer;
          setTimeout(() => {    //<<<---    using ()=> syntax
              this.attachViewer.showDialog(this.sAttachViewUrl, extension);
          }, 200);
      } else { //downlad attachment
          this.onDownloadAttachment(selectedAttachment.fileInfo);
      }
  }
  

}
getFileBlob(attachmentUrl: any) {
  return this.http.get(attachmentUrl, { responseType: "blob" }).subscribe((result: any) => {
      const data =  new Blob([result], { type: "image/png" });
      console.log("Sample data " + data);
      copyBlobToClipboard(data).then(() => {
          console.log("Blob copied to clipboard");
      });
  });
}
setAttachmentUrl(attachments: any): any {
  if (Array.isArray(attachments)) {

      console.log('Only one attachment : ', attachments[0].name);
      this.sAttachViewUrl = this.inboxService.viewAttachment(attachments[0].id, attachments[0].name, attachments[0].convId, attachments[0].groupId, attachments[0].hasNominatedOwnership);
  }
  else {
      console.log('Only one attachment : ', attachments.name);
      this.sAttachViewUrl = this.inboxService.viewAttachment(attachments.id, attachments.name, attachments.convId, attachments.groupId, attachments.hasNominatedOwnership);
  }

}
}
